module.exports = __webpack_public_path__ + "img/xuebitu.0cb6fddc.jpg";